import { createAsyncThunk } from "@reduxjs/toolkit";
import { BranchCode } from "api/risk";
import { BrancheCode } from "enums/brancheCode";
import { ProfilingMode } from "features/subscription-process/profiling-process/slices/types/enums";
import { ProfilingConfig } from "features/subscription-process/profiling-process/types/interfaces";
import { BorrowerStepIdentifier, UnemploymentStepIdentifier, UPIStepIdentifier } from "features/subscription-process/types/enums";
import { SimulationConfig, SubscriptionProcessStep } from "features/subscription-process/types/interfaces";
import { questionsChomage, questionValidationRules } from "./mockChomageQuestions";


interface InitSubscriptionProcessParams {
  branchCode: BranchCode;
  riskId: string
  folderIdentifier: string
}

export const initSubscriptionProcess = createAsyncThunk(
  'subscriptionProcess/init',
  async ({ branchCode, riskId, folderIdentifier }: InitSubscriptionProcessParams) => {
    let simulationConfig: SimulationConfig = {
      title: 'SUBSCRIPTION_PROCESS.TITLE.CREATE_UNEMPLOYMENT_PROJECT',
      folderIdentifier,
      steps: [
        { id: 1, stepIdentifiers: [UnemploymentStepIdentifier.Registration, UnemploymentStepIdentifier.Profiling], name: "COMMON.LABELS.FOLDER_CREATION" },
        { id: 2, stepIdentifiers: [UnemploymentStepIdentifier.Pricing], name: "COMMON.LABELS.PRICING" },
        { id: 3, stepIdentifiers: [UnemploymentStepIdentifier.Pricing], name: "COMMON.LABELS.QUOTE_CREATION" },
        { id: 4, stepIdentifiers: [UnemploymentStepIdentifier.Contractualization], name: "COMMON.LABELS.CONTRACT_CREATION" },
      ]
    }

    let step: SubscriptionProcessStep = {
      stepIdentifier: UnemploymentStepIdentifier.Registration,
      isValid: false,
      isCurrent: true,
    }

    let profilingConfig: ProfilingConfig = {
      questionsGroups: questionsChomage,
      validationRules: questionValidationRules,
      mode: ProfilingMode.AutoAdvance
    }

    switch (branchCode) {
      case BranchCode.Borrower:
        simulationConfig = {
          title: 'SUBSCRIPTION_PROCESS.TITLE.CREATE_BORROWER_PROJECT',
          folderIdentifier,
          steps: [
            { id: 1, stepIdentifiers: [BorrowerStepIdentifier.Project], name: "COMMON.LABELS.PROJECT" },
            { id: 2, stepIdentifiers: [BorrowerStepIdentifier.Pricing], name: "COMMON.LABELS.PRICING" },
            { id: 3, stepIdentifiers: [BorrowerStepIdentifier.Contractualization], name: "COMMON.LABELS.CONTRACT_CREATION" },
          ]
        }
        step = {
          stepIdentifier: BorrowerStepIdentifier.Project,
          isValid: false,
          isCurrent: true,
        }
        break;

      case BrancheCode.CBNO:
        simulationConfig = {
          title: 'SUBSCRIPTION_PROCESS.TITLE.CREATE_UPI_PROJECT',
          folderIdentifier,
          steps: [
            { id: 1, stepIdentifiers: [UPIStepIdentifier.Registration, UPIStepIdentifier.RealEstateRegistration], name: "COMMON.LABELS.FOLDER_CREATION" },
            { id: 2, stepIdentifiers: [UPIStepIdentifier.Pricing], name: "COMMON.LABELS.PRICING" },
            { id: 3, stepIdentifiers: [UPIStepIdentifier.Pricing], name: "COMMON.LABELS.QUOTE_CREATION" },
            { id: 4, stepIdentifiers: [UPIStepIdentifier.Contractualization], name: "COMMON.LABELS.CONTRACT_CREATION" },
          ]
        }
        step = {
          stepIdentifier: UPIStepIdentifier.Registration,
          isValid: false,
          isCurrent: true,
        }
        break;
    }

    return {
      riskId,
      folderIdentifier,
      branch: branchCode,
      profilingConfig,
      simulationConfig,
      step
    }

  }
);
